import Vue from "vue";

// Sections
import Brew from './Brew.vue';
import * as utils from "../../utils/units";

import GramsLabel from "../../components/GramsLabel.vue";
import KgLabel from "../../components/KgLabel.vue";
import LiquidLabel from "../../components/LiquidLabel.vue";
import SrmLabel from "../../components/SrmLabel.vue";
import TempLabel from "../../components/TempLabel.vue";
import PercentChange from "../../components/PercentChange.vue";

Vue.component("grams-label", GramsLabel);
Vue.component("kg-label", KgLabel);
Vue.component("liquid-label", LiquidLabel);
Vue.component("srm-label", SrmLabel);
Vue.component("temp-label", TempLabel);
Vue.component("percent-change", PercentChange);

import * as filters from "../../utils/filters";
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

import store from "./store"

Vue.config.productionTip = false;

const brewVue = new Vue({
  store,
  render: (h) => h(Brew),
});

brewVue.$mount("#vueapp");



//////////////////
// WEBPACK FOOTER
// ./src/sections/brew/main.js
// module id = 625
// module chunks = 6